import { httpService } from '@/api/v1/http.service'
import useDownload, { type DownloadParams } from '@/hooks/useDownload'
import { type CommentsParams } from '@/queries/useComments'
import { formatApiDate } from '@/utils/format-date'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

type Params = DownloadParams & CommentsParams

const useCommentsDownload = (commentsDownloadParams: Params) => {
  const columns = [...(commentsDownloadParams.columnsKey ?? []), 'content']

  return useDownload({
    fileName: 'comments',
    requestParams: commentsDownloadParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: Params) =>
      httpService.panel.panelCommentsList(
        {
          format: params.format,
          added_by_id: params.addedById,
          comment_type: params.commentType,
          date_after: params.dateAfter
            ? formatApiDate(new Date(params.dateAfter))
            : undefined,
          date_before: params.dateBefore
            ? formatApiDate(new Date(params.dateBefore))
            : undefined,
          group_id: params.groupId,
          class_id: params.classId,
          course_id: params.coursesId,
          student_id: params.studentsId,
          semester_id: params.semester,
          page_size: params.pageSize,
          page: params.page,
          fetchKeys: parseColumnsToFetchKeys(columns, params.format)
        },
        { format: 'blob' }
      )
  })
}

export default useCommentsDownload
